export default __webpack_public_path__ + "static/media/background.12aad9cf.jpg";